<template>
  <div class="content-toolbar">
    <div class="drag-area" ref="dragArea">
      <div class="tools-container">
        <div class="tool" v-if="isFrontEnd && !isToolsEdit">
          <div class="toolArea">
            <div class="editTools">
                <i class="iconfont icon-bianji"
                  @click="editToolsFun(config, 0)"
                  title="编辑"
                ></i>
            </div>
          </div>
        </div>
        <div class="drag-left-content">
          <div
            :key="comps.id"
            v-for="comps in getLeftLayout(config.toolbarConfig)"
            class="drag-list"
          >
            <button-comp
              :themeColor="themeColor"
              v-if="comps.type === 'button' && (isFrontEnd || !isFrontEnd && !comps.butShow)"
              :info="comps"
              :configComponent="configComponent"
              :summary="summary"
              :customDeskInfo="customDeskInfo"
              @change-filed="$emit('change-filed', $event)"
              @viewButton="buttonClick"
              @retRefresh="retRefresh"
              @edit-user="toolbarEditUser"
              @usual="(val, obj) => usual(val, comps, obj)"
              @upSummary="upSummary"
              @closeButton="closeButton"
            ></button-comp>
            <search-comp
              :themeColor="themeColor"
              v-else-if="comps.type === 'search'"
              :info="comps"
              @viewSearch="(val) => searchClick(val, comps)"
            ></search-comp>
            <div v-else-if="comps.type === 'screen' && !comps.butShow" :style="comps.customW ? ('width:' + comps.customW + 'px') : ''">
              <screen-comp
                :themeColor="themeColor"
                :info="comps"
                :configComponent="configComponent"
                :isReport="isReport"
                @viewScreen="(val) => searchClick(val, comps)"
              ></screen-comp>
            </div>
          </div>
        </div>
        <div class="drag-right-content">
          <div
            :key="comps.id"
            v-for="comps in getRightLayout(config.toolbarConfig)"
          >
            <button-comp
              :themeColor="themeColor"
              v-if="comps.type === 'button' && (isFrontEnd || !isFrontEnd && !comps.butShow)"
              :info="comps"
              :summary="summary"
              :configComponent="configComponent"
              :customDeskInfo="customDeskInfo"
              @change-filed="$emit('change-filed', $event)"
              @usual="(val, obj) => usual(val, comps, obj)"
              @viewButton="buttonClick"
              @edit-user="toolbarEditUser"
              @retRefresh="retRefresh"
              @upSummary="upSummary"
              @closeButton="closeButton"
            ></button-comp>
            <search-comp
              :themeColor="themeColor"
              v-else-if="comps.type === 'search'"
              :info="comps"
              @viewSearch="(val) => searchClick(val, comps)"
            ></search-comp>
            <div v-else-if="comps.type === 'screen' && !comps.butShow" :style="comps.customW ? ('width:' + comps.customW + 'px') : ''">
              <screen-comp
                :themeColor="themeColor"
                :info="comps"
                :configComponent="configComponent"
                :isReport="isReport"
                @viewScreen="(val) => searchClick(val, comps)"
              ></screen-comp>
            </div>
          </div>
        </div>
      </div>
    </div>
    <model-vue
      v-model:visiable="isToolsEdit"
      :dataInfo="goEdit"
      :applyType="config"
      :contentStyle="contentStyle"
      :modelWidth="modelWidth"
      :configComponent="configComponent"
      :summary="summary"
      :column="column"
      @editCallBack="editCallBack"
    ></model-vue>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'


export default {
  name: "toolBar",
  props: {
    config: {
      type: Object
    },
    // 默认为下级的组件
    configComponent: {
      type: Object
    },
    index: Number,
    isFrontEnd: Boolean,
    drowStyel: {
      type: Object
    },
    noBotton: {
      type: Boolean,
      default: false
    },
    // 这个是关联过来的
    isReport: {
      type: Boolean,
      default: false
    },
    summary: {
      type: Array,
      default: ()=>([])
    },
    column: {
      type: Array,
      default: () => []
    },
    customDeskInfo: {
      type: Object,
      default: () => {}
    }
  },
  provide () {
    return {
      noBotton: this.noBotton
    }
  },
  components: {
    buttonComp: defineAsyncComponent(() => import('./button')),
    screenComp: defineAsyncComponent(() => import('./screen')),
    searchComp: defineAsyncComponent(() => import('./search')),
    modelVue: defineAsyncComponent(() => import('./tools/model'))
  },
  data () {
    return {
      // 点击模板的信息
      contentStyle: {
        width: '100px',
        height: '100px',
        left: 0,
        top: 0
      },
      isToolsEdit: false,
      // 此参数中台那边似乎是固定的，这边没有配置项，直接写固定
      themeColor: '#4e86ff',
      // 暂时储存一个组件的配置信息
      goEdit: null,
      modelWidth: ''
    }
  },
  watch: {
    isToolsEdit: {
      immediate: true,
      handler (val) {
        this.$emit('upDrage', val)
      }
    }
  },
  methods: {
    closeButton () {
      this.$emit('closeButton', this.configComponent.i)
    },
    upSummary (config) {
      console.log('更改汇总', config, this.configComponent)
      this.$emit('upSummary', { ...config, uId: this.configComponent.i })
    },
    toolbarEditUser (config) {
      this.$emit('toolbar-edit-user', {config, i: this.configComponent.i, user: this.configComponent.user })
    },
    usual (val, config, obj) {
      let obs = {config: config, type: val}
      if (obj) {
        obs = { ...obs, ...obj }
      }
      console.log('点击的', obs, obj)

      this.$emit('usual', obs)
    },
    retRefresh (val) {
      this.$emit('retRefresh', val)
    },
    buttonClick (val) {
      console.log('按钮点击触发', val)
      if (this.isToolsEdit) return
      const obj = {
        ...val.insideInfo
      }
      if (val.bindingFunction === 'inside') {
        if (obj.id === undefined) {
          obj.id = this.config && this.config.i ? this.config.i : ''
        }
        obj.link = 2
      }
      if (val.bindingFunction === 'ability') {
        obj.link = 4
        obj.appid = val.appId
      }
      const obs = {item:obj, value: {}, user: this.config.user || [], id: ''}
      if (val.bindingFunction === 'custom-scene') {
        obs.customScene = val.customScene
      }
      // 做成单个点击结构返回回去
      this.$emit('singleRelevanceConfig', obs)
    },
    searchClick (val, item) {
      console.log('搜索回来出发', val, item)
      if (this.isToolsEdit) return
      // const vals = val || val === 0 ? (Array.isArray(val) ? val : [val]) : []
      const obj = {
        filterId: item.i,
        title: item.newDataName ? item.newDataName : (item.checkName || item.name),
        // title: item.name,
        // value: item.type === 'search' ? val : vals,
        value: val || val === 0 ? (Array.isArray(val) ? val : [val]) : [],
        checkName: item.checkName,
        isCustom: item.isCustom ? true : false,
        relation: item.screenType === 'date' ? 'between' : item.activeName ? (item.activeName !== 'text' ? 'in' : 'like') : 'like'
      }
      if (item.isCustom) {
        obj.customName = item.customName ? item.customName : item.checkName
        if (item.screenType === 'date' && item.customName2) {
          obj.customName2 = item.customName2
        }
      }
      // 如果是筛选组件，需要把值再上层修改下
      if (item.type === 'screen') {
        this.config.toolbarConfig.forEach(its => {
          if (its.i === item.i) its.FilterValue = val
        })
      }
      if (this.isReport && !item.checkName && item.checkName !== 0) {
        obj.title = item.info.syllable.name
      }
      // 如果是搜索组件，并且为关联单选查询打开
      if (this.isReport && item.type === 'search') {
        obj.value = obj.value.join('')
      }
      // 搜索走关联类型回去搜索，和筛选一样使用
      this.$emit('searchRelevanceConfig', {search: obj, i: this.configComponent.i})
    },
    getRightLayout (value) {
      return (value || []).filter((item) => item.isLeft === false)
    },
    getLeftLayout (value) {
      return (value || []).filter((item) => item.isLeft === true || item.isLeft === undefined)
    },
    editToolsFun (datas, index) {
      // - 根据不同的datas.type执行自己的方法，方法可以放入insintrument.js（通用公共方法存放地）
      this.goEdit = JSON.parse(JSON.stringify(datas))
      console.log('查看宽高', this.$refs.dragArea, index, this.$refs.dragArea.getBoundingClientRect())
      const demo = this.$refs.dragArea
      if (demo) {
        const address = demo.getBoundingClientRect()
        const obj = {
          width: parseInt(address.width - 10) + 'px',
          height: parseInt(address.height) + 'px',
          left: parseInt(address.left) + 'px',
          top: parseInt(address.top) + 'px',
        }
        if (this.drowStyel && (this.drowStyel.l || this.drowStyel.t)) {
          obj.left = this.drowStyel.l
          obj.top = this.drowStyel.t
        }
        this.$set(this, 'contentStyle', obj)
      }
      this.isToolsEdit = true
    },
    // 编辑保存回来的
    editCallBack (callbackDatas) {
      console.log('编辑保存回来的', callbackDatas)
      this.$set(this.config, 'toolbarConfig', callbackDatas.toolbarConfig)
    },
  }
}
</script>

<style scoped lang="scss">
.content-toolbar {
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
}
.drag-area {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  &:hover {
    .tools-container {
      .tool {
        display: block;
      }
    }
  }

  .tools-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    .drag-list {
      padding-left: 5px;
      padding-right: 5px;
    }

    .drag-left-content {
      display: flex;
      height: 30px;
      .drag-list:nth-child(1) {
        padding-left: 0;
      }
    }

    .drag-right-content {
      display: flex;
      height: 30px;
      justify-content: flex-end;
      .drag-list:last-child {
        padding-right: 0;
      }
    }

    .tool {
      position: absolute;
      display: none;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 9999;
      background: rgba(0, 0, 0, 0.5);

      .toolArea {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
        justify-content: center;

        .editTools {
          // color: #fff;
          margin-right: 10px;
        }

        .iconfont {
          color: #fff;

          &:hover {
            color: #4e86ff;
          }
        }
      }
    }
  }
}
</style>
